import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { CALL_API } from 'redux-api-middleware';
import { preserveSequence } from '../../middleware/sequence';
import { ADD_ORDER_ITEM, CLEAR_NEW_ORDER_FLOW, FETCH_AMPS_RECEIVE, FETCH_REORDER_RECEIVE } from '../neworder';
import { MEDICINE_API } from '../../../../config/endpoints';
import { validate } from '../../middleware/validator';

// ACTIONS
export const FETCH_MEDICINES_REQUEST = 'ADD_MEDICINE/FETCH_MEDICINES_REQUEST';
export const FETCH_MEDICINES_RECEIVE = 'ADD_MEDICINE/FETCH_MEDICINES_RECEIVE';
export const FETCH_MEDICINES_FAILURE = 'ADD_MEDICINE/FETCH_MEDICINES_FAILURE';
export const SELECT_MEDICINE = 'ADD_MEDICINE/SELECT';
export const SET_EMPTY_LIST = 'ADD_MEDICINE/SET_EMPTY_LIST';

// ACTION CREATORS
const loadMedicines = (text, filters, apiEndpoint) => {
  // const url = new URL(`${apiEndpoint}/search/${filters && filters.devicesOnly ? 'wardles/' : ''}${encodeURIComponent(text.trim())}`);
  const url = new URL(`${apiEndpoint}/drugs?q=${text.trim()}`)
  // eslint-disable-next-line no-unused-vars
  function withQueryString(baseUrl, data) {
    // const entries = Object.entries(data);
    // if (!entries.length) return baseUrl.toString();
    // entries.forEach(([k, v]) => url.searchParams.append(k, String(!!v)));
    return baseUrl.toString();
  }
  return {
    [CALL_API]: {
      endpoint: withQueryString(url, filters),
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      types: preserveSequence([
        FETCH_MEDICINES_REQUEST,
        FETCH_MEDICINES_RECEIVE,
        FETCH_MEDICINES_FAILURE,
      ]).map(action => ({ ...action, meta: { ...action.meta, text } })),
      options: { addAuth: true },
    },
  };
};

export const searchMedicines = (text = '', filters = {}, apiEndpoint = MEDICINE_API) => ({
  type: 'SEARCH_MEDICINE_VALIDATION',
  [validate]: {
    validator: () => (text && text.length),
    success: loadMedicines(text, filters, apiEndpoint),
    fail: { type: SET_EMPTY_LIST },
  },
});

export const selectMedicine = index => ({
  type: SELECT_MEDICINE,
  index,
});

// SELECTORS
export const getMedicines = state => state.medicines;
export const getMedicinesList = state => state.medicinesList;
export const getSearchText = state => state.search;
export const getSelectedIndex = state => state.selectedIndex;
export const getResultsLoaded = state => state.resultsLoaded;
export const getHasNoResults = state => getResultsLoaded(state) && getMedicinesList(state).length === 0;
export const getHasError = state => state.error != null;

// REDUCERS
export const medicines = handleActions({
  [SET_EMPTY_LIST]: () => [],
  [ADD_ORDER_ITEM]: () => [],
  [CLEAR_NEW_ORDER_FLOW]: () => [],
  [FETCH_AMPS_RECEIVE]: (state, action) => action.payload.data,
  [FETCH_REORDER_RECEIVE]: (state, action) => action.payload.data?.sort((a, b) => b?.lastOrdered > a?.lastOrdered ? 1 : -1)?.map(item=>item.medicine)
}, []);

export const medicinesList = handleActions({
  [SET_EMPTY_LIST]: () => [],
  [ADD_ORDER_ITEM]: () => [],
  [CLEAR_NEW_ORDER_FLOW]: () => [],
  [FETCH_MEDICINES_RECEIVE]: (state, action) => action.payload.data,
}, []);

export const search = handleActions({
  [SET_EMPTY_LIST]: () => '',
  [ADD_ORDER_ITEM]: () => '',
  [CLEAR_NEW_ORDER_FLOW]: () => '',
  [FETCH_MEDICINES_REQUEST]: (state, action) => action.meta.text,
}, '');

export const selectedIndex = handleActions({
  [SET_EMPTY_LIST]: () => null,
  [ADD_ORDER_ITEM]: () => null,
  [FETCH_MEDICINES_REQUEST]: () => null,
  [CLEAR_NEW_ORDER_FLOW]: () => null,
  [SELECT_MEDICINE]: (state, action) => action.index,
}, null);

export const resultsLoaded = handleActions({
  [SET_EMPTY_LIST]: () => true,
  [ADD_ORDER_ITEM]: () => false,
  [FETCH_MEDICINES_REQUEST]: () => false,
  [FETCH_MEDICINES_RECEIVE]: () => true,
  [CLEAR_NEW_ORDER_FLOW]: () => false,
}, false);

export const error = handleActions({
  [SET_EMPTY_LIST]: () => null,
  [ADD_ORDER_ITEM]: () => null,
  [FETCH_MEDICINES_REQUEST]: () => null,
  [CLEAR_NEW_ORDER_FLOW]: () => null,
  [FETCH_MEDICINES_FAILURE]: (state, action) => action.payload,
}, null);

export default combineReducers({
  medicines,
  medicinesList,
  search,
  selectedIndex,
  resultsLoaded,
  error,
});
